'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Play, ChevronDown } from 'lucide-react';

export default function HeroSection() {
  const [videoPlaying, setVideoPlaying] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0D0B08]">
      {/* Background — gradient overlay simulating video background */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(ellipse at 30% 50%, rgba(196, 154, 108, 0.15) 0%, transparent 60%),
              radial-gradient(ellipse at 70% 30%, rgba(90, 122, 90, 0.08) 0%, transparent 50%),
              linear-gradient(180deg, #0D0B08 0%, #1A1510 50%, #0D0B08 100%)
            `,
          }}
        />
        {/* Grain texture */}
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
            backgroundSize: '200px 200px',
          }}
        />
      </div>

      {/* Video play button overlay */}
      {!videoPlaying && (
        <button
          onClick={() => setVideoPlaying(true)}
          className="absolute bottom-32 right-8 md:right-16 lg:right-24 z-20 flex items-center gap-3 text-white/60 hover:text-white/90 transition-all duration-300 group"
          aria-label="Watch video"
        >
          <div className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center group-hover:border-white/60 group-hover:scale-110 transition-all duration-300">
            <Play size={16} className="ml-0.5" fill="currentColor" />
          </div>
          <span className="text-xs tracking-widest uppercase font-500">Смотреть</span>
        </button>
      )}

      {/* Main content */}
      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
        {/* Eyebrow */}
        <div className="mb-8 inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/10 bg-white/5">
          <span className="w-1.5 h-1.5 rounded-full bg-[#C49A6C] animate-pulse" />
          <span className="text-xs tracking-widest uppercase text-white/50">svyatosha talks</span>
        </div>

        {/* Main headline */}
        <h1
          className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-300 text-white leading-[1.05] mb-8 text-balance"
          style={{ fontWeight: 300, letterSpacing: '-0.02em' }}
        >
          Ты не то,<br />
          <em style={{ fontStyle: 'italic', fontWeight: 300 }}>что ты думаешь</em>
        </h1>

        {/* Sub */}
        <p className="text-base md:text-lg text-white/40 mb-12 max-w-md mx-auto leading-relaxed" style={{ fontWeight: 300 }}>
          Видео о том, кто ты есть на самом деле. Без религии. Без системы. Просто — осознанность.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#videos"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full bg-white text-[#0D0B08] text-sm font-500 hover:bg-white/90 transition-all duration-200 active:scale-95"
          >
            <Play size={14} fill="currentColor" />
            Смотреть
          </a>
          <Link
            href="/membership-landing"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full border border-white/20 text-white text-sm font-500 hover:border-white/40 hover:bg-white/5 transition-all duration-200 active:scale-95"
          >
            Войти глубже
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/30">
        <span className="text-xs tracking-widest uppercase" style={{ fontSize: '10px' }}>Scroll</span>
        <ChevronDown size={16} className="animate-bounce" />
      </div>
    </section>
  );
}